import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CutIcon } from "@/assets/icons/cut-bold.svg";
import { ReactComponent as VolumeIcon } from "@/assets/icons/volume-lound.svg";
import { ReactComponent as SpeedIcon } from "@/assets/icons/speed-bold.svg";
import sentGAEvent from "@/ga";

import "@/assets/audioCutSpeedVolume.less";

const AudioWorkHeaderRender = ({ pageWork, handelPageWorkChange }) => {
  const { t } = useTranslation(["audioCutAndSpeedAndVolume"]);
  return (
    <div className="workplace-header">
      <div
        onClick={() => {
          handelPageWorkChange("audioCut");
          sentGAEvent({
            category: "audio_cut_action",
            action: "audio_cut_tab_click",
          });
        }}
        className={`${pageWork === "audioCut" ? "active" : ""} nav-item`}
      >
        <CutIcon />
        <span>{t("Cut")}</span>
      </div>
      <div
        onClick={() => {
          handelPageWorkChange("audioVolume");
          sentGAEvent({
            category: "audio_volume_action",
            action: "audio_volume_tab_click",
          });
        }}
        className={`${pageWork === "audioVolume" ? "active" : ""} nav-item`}
      >
        <VolumeIcon />
        <span>{t("Volume")}</span>
      </div>
      <div
        onClick={() => {
          handelPageWorkChange("audioSpeed");
          sentGAEvent({
            category: "audio_speed_action",
            action: "audio_speed_tab_click",
          });
        }}
        className={`${pageWork === "audioSpeed" ? "active" : ""} nav-item`}
      >
        <SpeedIcon />
        <span>{t("Speed")}</span>
      </div>
    </div>
  );
};

export default AudioWorkHeaderRender;
